// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-5nqg"};